import { FILTERDEFAULTS } from 'global/components/filterchips/definitions';
import { cleanCopy } from 'global/utils';

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  data: {
    scorecards: [],
  },
  view: {
    task: {
      new: [],
      ignored: [],
      sent: [],
      list: [],
    },
    alerts: {
      new: [],
      user: [],
      all: [],
    },
    hasLoadedTheme: false,
    hasShownWelcome: false,
    dontAskTaskDelete: false,
    sendReceipt: false,

    createTaskOnScore: true,
    dontShowTaskOnScore: false,

    style: {
      palette: {
        mode: 'light',
      },
    },
    edit: {
      on: false,
    },
    lang: {
      //this acts like a filter, but we are keeping it here because we want it to persist
      id: 'en',
      avail: [
        { id: 'en', title: 'English' },
        { id: 'sp', title: 'Spanish' },
      ],
    },
  },
  filter: cleanCopy(FILTERDEFAULTS),
  auth: {
    permissions: [],
    userId: null,
    email: null,
    accessToken: null,
    refreshToken: null,
    loginFailed: null,
    loginStarted: null,
    accessTokenValidUntil: 0,
    accessTokenSetAt: 0,
    realm: null,
    accountSettings: [],
  },
};
